import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyBPGeZFY3ERX2-dISPLOONqGDYP--Rm5-o",
  authDomain: "fall-detection-app-cyh.firebaseapp.com",
  projectId: "fall-detection-app-cyh",
  storageBucket: "fall-detection-app-cyh.appspot.com",
  messagingSenderId: "1083477989839",
  appId: "1:1083477989839:web:9b63f71c9ae21057861aba",
};

const app = initializeApp(firebaseConfig);

export const authentication = getAuth(app);
export const storage = getStorage(app);
